import { Outlet } from "react-router-dom";

import { useIframeInitialization } from "@src/features/iframe";
import { Toaster } from "@src/shared/components/ui/sonner";

export default function Root() {
  useIframeInitialization();

  return (
    <>
      <Outlet />
      <Toaster />
    </>
  );
}
